import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import SearchPage from "@/pages/SearchPage";
import ExhibitionPage from "@/pages/ExhibitionPage";
import OrganizerPage from "@/pages/OrganizerPage";
import OrganizersPage from "@/pages/OrganizersPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/exhibitions" element={<SearchPage />} />
          <Route path="/exhibition/:id" element={<ExhibitionPage />} />
          <Route path="/organizers" element={<OrganizersPage />} />
          <Route path="/organizer/:id" element={<OrganizerPage />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
